import React from 'react';
import PropTypes from 'prop-types';
import { preventSubmitWithENTER } from 'helpers';
import { Input } from '@/components/ui/input';
// import { Button } from '@/components/ui/button';

const TableSection = ({ title, description, actionLabel, onAction, onSearch, searchPlaceholder, children }) => {
  console.log(typeof actionLabel);
  console.log(typeof onAction);

  return (
    <section className="min-h-screen w-full bg-gradient-to-br from-hajj-muted via-white to-green-50 flex items-start justify-center py-10">
      <div className="w-[90%] max-w-6xl space-y-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-2xl font-semibold">{title}</h2>
            <p className="text-gray-600">{description}</p>
          </div>
          {/* <Button onClick={onAction} className="mt-4 md:mt-0">
            {actionLabel}
          </Button> */}
        </div>

        {/* Search Bar */}
        <div>
          <Input
            placeholder={searchPlaceholder}
            className="w-full"
            onChange={(e) => onSearch?.(e.target.value)}
            onKeyDown={preventSubmitWithENTER}
          />
        </div>

        {/* Table or other content */}
        <div className="bg-white rounded-2xl shadow-sm p-4">{children}</div>
      </div>
    </section>
  );
};

TableSection.defaultProps = {
  description: null,
  actionLabel: null,
  onAction: null,
  onSearch: null,
  searchPlaceholder: null,
};

TableSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  onSearch: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default TableSection;
